<div class="report-container">
  <div class="report-header">
    <div class="title-section">
      <h2 class="modern-title">Profit & Loss</h2>
      <p class="modern-subtitle">Financial performance overview</p>
    </div>

    <div class="controls-section">
      <div class="btn-group modern-btn-group">
        @for (p of periods; track p) {
          <button
            class="btn modern-filter-btn"
            [class.active]="period === p"
            (click)="setPeriod(p)">
            {{ p }}
          </button>
        }
      </div>

      @if (period === 'Custom') {
        <div class="custom-date-section ms-3 d-flex align-items-center">
          <input type="date" [(ngModel)]="startDate" class="date-input">
          <span class="mx-2" style="color: white">to</span>
          <input type="date" [(ngModel)]="endDate" class="date-input">
          <button class="btn modern-action-btn primary-btn ms-2" (click)="applyCustomRange()">Apply</button>
        </div>
      }

      <button class="btn modern-action-btn primary-btn ms-3" (click)="exportPdf()">
        Export PDF
      </button>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-cards">
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Total Revenue</div>
        <div class="card-value text-revenue">{{ totalRevenue | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Cost of Goods Sold</div>
        <div class="card-value text-cogs">{{ totalCogs | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Gross Profit</div>
        <div class="card-value text-gross">{{ grossProfit | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Total Expenses</div>
        <div class="card-value text-expense">{{ totalExpenses | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card highlight-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Net Income</div>
        <div class="card-value text-net">{{ netIncome | currency }}</div>
      </div>
    </div>
  </div>

  <div class="chart-section glass-card mt-4">
    <div class="section-header d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center">
        <h3 class="section-title">Financial Performance</h3>
        <span class="ms-2 period-tag">{{ period }}</span>
      </div>
      <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle financial performance chart" title="Toggle financial performance chart" (click)="isChartCollapsed = !isChartCollapsed">
      </button>
    </div>
    <div [collapse]="isChartCollapsed" [isAnimated]="true">
      <div class="charts-grid">
        <div class="chart-wrapper">
          @if (chartOptions) {
            <ag-charts [options]="chartOptions"></ag-charts>
          }
        </div>
        <div class="chart-wrapper">
          @if (pieChartOptions) {
            <ag-charts [options]="pieChartOptions"></ag-charts>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Detailed Breakdown -->
  <div class="row mt-4 mb-4">
    <!-- Income -->
    <div class="col-md-6">
      <div class="breakdown-card glass-card" [class.is-collapsed]="isIncomeCollapsed">
        <div class="section-header d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <h3 class="section-title text-revenue mb-0">Income</h3>
            <span class="ms-2 period-tag">{{ period }}</span>
            <span class="badge revenue-badge ms-2">{{ totalRevenue | currency }}</span>
          </div>
          <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle income breakdown" title="Toggle income breakdown" (click)="isIncomeCollapsed = !isIncomeCollapsed">
          </button>
        </div>
        <div [collapse]="isIncomeCollapsed" [isAnimated]="true">
          <div class="grid-wrapper">
            <ag-grid-angular
              style="width: 100%;"
              
              [gridOptions]="gridOptions"
              [rowData]="incomeRowData"
              [columnDefs]="incomeColDefs">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>

    <!-- Expenses -->
    <div class="col-md-6 mt-4 mt-md-0">
      <div class="breakdown-card glass-card" [class.is-collapsed]="isExpenseCollapsed">
        <div class="section-header d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <h3 class="section-title text-expense mb-0">Expenses</h3>
            <span class="ms-2 period-tag">{{ period }}</span>
            <span class="badge expense-badge ms-2">{{ totalExpenses | currency }}</span>
          </div>
          <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle expense breakdown" title="Toggle expense breakdown" (click)="isExpenseCollapsed = !isExpenseCollapsed">
          </button>
        </div>
        <div [collapse]="isExpenseCollapsed" [isAnimated]="true">
          <div class="grid-wrapper">
            <ag-grid-angular
              style="width: 100%;"
              
              [gridOptions]="gridOptions"
              [rowData]="expenseRowData"
              [columnDefs]="expenseColDefs">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
